import * as types from './types'

export default {

  [types.SET_CALIBRATION_HOMEPAGE_MESSAGE](state, data) {
    state.calibrationHomepageMessage = data
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/notificationmessage/mutations.js